import { Controller } from "@hotwired/stimulus"

// Owns which search tab is selected (AI Search / ES|QL / Query Builder) and
// broadcasts that view state. Note: this is the *tab* state — whether the
// textarea content actually parses as ES|QL is derived downstream by
// accounts--logs--query-type.
export default class extends Controller {
  static targets = [
    "advancedSearch",
    "advancedSearchButton",
    "queryBuilder",
    "queryBuilderButton",
    "aiSearch",
    "aiSearchButton"
  ]

  connect() {
    const urlParams = new URLSearchParams(window.location.search)
    const searchType = urlParams.get("search_type")

    if (searchType === "ai" && this.hasAiSearchTarget) {
      this.switchToAiSearch()
    } else {
      this.#broadcast(this.#detectInitialMode())
    }
  }

  switchToAiSearch() {
    if (!this.hasAiSearchTarget) return

    this.#clearSelected()
    this.aiSearchButtonTarget.classList.add("selected-search-type")
    this.aiSearchTarget.classList.remove("hidden")
    this.advancedSearchTarget.classList.add("hidden")
    this.queryBuilderTarget.classList.add("hidden")
    this.#broadcast("ai_search")
  }

  switchToAdvancedSearch() {
    this.#clearSelected()
    this.advancedSearchButtonTarget.classList.add("selected-search-type")
    this.advancedSearchTarget.classList.remove("hidden")
    if (this.hasAiSearchTarget) {
      this.aiSearchTarget.classList.add("hidden")
    }
    this.queryBuilderTarget.classList.add("hidden")
    this.#broadcast("esql")
  }

  switchToQueryBuilder() {
    this.#clearSelected()
    this.queryBuilderButtonTarget.classList.add("selected-search-type")
    this.queryBuilderTarget.classList.remove("hidden")
    this.advancedSearchTarget.classList.add("hidden")
    if (this.hasAiSearchTarget) {
      this.aiSearchTarget.classList.add("hidden")
    }
    this.#broadcast("query_builder")
  }

  #detectInitialMode() {
    if (!this.queryBuilderTarget.classList.contains("hidden")) return "query_builder"
    return "esql"
  }

  #broadcast(mode) {
    document.body.dataset.logsViewMode = mode
    document.dispatchEvent(new CustomEvent("logs:view-mode-changed", { detail: { mode } }))
  }

  #clearSelected() {
    if (this.hasAiSearchButtonTarget) {
      this.aiSearchButtonTarget.classList.remove("selected-search-type")
    }
    this.advancedSearchButtonTarget.classList.remove("selected-search-type")
    this.queryBuilderButtonTarget.classList.remove("selected-search-type")
  }
}
